export function isGeneratedFileSavedDocument(file) {
  if (!file?.document_uuid) return false;
  return file.isAgentFile !== true && file.is_agent_file !== true;
}

export function buildGeneratedFileCanvasDocument(file, fallbackProjectUuid = null) {
  if (isGeneratedFileSavedDocument(file)) {
    return {
      uuid: file.document_uuid,
      name: file.filename,
      file_type: file.file_type,
      file_size: file.size,
      project_uuid: file.project_uuid || fallbackProjectUuid || null,
      isAgentFile: false,
    };
  }

  return {
    name: file.filename,
    file_type: file.file_type,
    url: file.url,
    isAgentFile: true,
  };
}
